"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FileUserSolid: function() {
        return FileUserSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FileUserSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 4C3 2.34315 4.34315 1 6 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289L20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4ZM14 3.5L18.5 8H15C14.4477 8 14 7.55228 14 7V3.5ZM11.9999 13C10.8954 13 9.99993 13.8954 9.99993 15C9.99993 16.1046 10.8954 17 11.9999 17C13.1045 17 13.9999 16.1046 13.9999 15C13.9999 13.8954 13.1045 13 11.9999 13ZM12.0011 18C14.0523 18 15.8133 19.2345 16.5847 21C13.3 21 10.7023 21 7.41748 21C8.18894 19.2345 9.94988 18 12.0011 18Z",
        fill: "currentColor"
    })
}), "FileUserSolid");
const _default = FileUserSolid;
